<div
  *ngIf="!loading || (activePanel == panel.key && !refreshCurrentPanel)"
  class="facet-category-search"
  [ngClass]="{ showSearchBar: !panel.showSearch }"
>
  <div class="facet-category-search-container">
    <div class="facet-category-searchbox">
      <nz-input-group nzSize="small" [nzPrefix]="prefixIcon">
        <input
          nzSize="small"
          class="facet-search-input category"
          #inputElement
          nz-input
          type="text"
          [placeholder]="placeholderValues[panel.key]"
          [(ngModel)]="facetCategorySearch[panel.key]"
          (keyup)="onFacetCategorySearch(panel)"
        />
      </nz-input-group>
      <ng-template #prefixIcon>
        <va-icon
          size="small"
          name="search"
          class="search-icon"
        ></va-icon>
      </ng-template>
    </div>
  </div>
</div>
